import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { saveBlob } from '../utils/saveBlob';
import { parseContentDispositionFilename } from '../utils/contentDisposition';

export interface AuditEvent {
  id: string;
  entityType: string;
  entityId: string;
  action: 'INSERT' | 'UPDATE' | 'SOFT_DELETE';
  documentRef: string | null;
  changedFields: string | null;
  userId: string | null;
  userName: string | null;
  occurredAt: string;
}

export interface AuditPage { content: AuditEvent[]; totalElements: number; number: number; size: number }

export interface AuditFilters { entityType?: string; userId?: string; from?: string; to?: string; documentRef?: string }

const clean = (f: AuditFilters) => ({
  entityType: f.entityType || undefined,
  userId: f.userId || undefined,
  from: f.from || undefined,
  to: f.to || undefined,
  documentRef: f.documentRef?.trim() || undefined,
});

export const AuditLogService = {
  list: async (institutionId: string, f: AuditFilters, page: number, size: number): Promise<AuditPage> =>
    (await axios.get(ENDPOINTS.AUDIT_LOG.LIST(institutionId), { params: { ...clean(f), page, size } })).data,

  entityTypes: async (institutionId: string): Promise<string[]> =>
    (await axios.get(ENDPOINTS.AUDIT_LOG.ENTITY_TYPES(institutionId))).data,

  /** Export uses the APPLIED filters. */
  exportXlsx: async (institutionId: string, f: AuditFilters): Promise<void> => {
    const response = await axios.get(ENDPOINTS.AUDIT_LOG.EXPORT(institutionId), { params: clean(f), responseType: 'blob' });
    const disposition: string = response.headers?.['content-disposition'] ?? '';
    saveBlob(new Blob([response.data]), parseContentDispositionFilename(disposition, 'audit-log.xlsx'));
  },
};
